export class BootstrapFormRenderer {
    render(instruction) {
        for (let { result, elements } of instruction.unrender) {
            for (let element of elements) {
                this.remove(element, result);
            }
        }

        for (let { result, elements } of instruction.render) {
            for (let element of elements) {
                this.add(element, result);
            }
        }
    }

    add(element, result) {
        if (result.valid) {
            return;
        }

        const formGroup = element.closest('.form-group');
        console.log(formGroup);
        if (!formGroup) {
            return;
        }

        // add the has-error class to the enclosing form-group div
        element.classList.add('is-invalid');
        element.parentElement.classList.add('is-invalid');

        // add help-block
        const message = document.createElement('span');
        message.className = 'invalid-feedback';
        message.textContent = result.message;
        message.id = `validation-message-${result.id}`;
        formGroup.appendChild(message);
    }

    remove(element, result) {
        if (result.valid) {
            return;
        }

        const formGroup = element.closest('.form-group');
        if (!formGroup) {
            return;
        }

        // remove help-block
        const message = formGroup.querySelector(`#validation-message-${result.id}`);
        if (message) {
            formGroup.removeChild(message);

            // remove the has-error class from the enclosing form-group div
            if (formGroup.querySelectorAll('.invalid-feedback').length === 0) {
                element.classList.remove('is-invalid');
                element.parentElement.classList.remove('is-invalid');
            }
        }
    }
}